<template>
  <b-navbar-nav class="ml-auto">
    <b-nav-item-dropdown right class="nav-margin">
      <template slot="button-content">
        <em>{{$store.state.name}}</em>
      </template>
      <b-dropdown-item class="gray-dark" to="/account/password/change">{{$t("navigation.passwordChange")}}</b-dropdown-item>
      <b-dropdown-item class="gray-dark" @click="openManual">マニュアル</b-dropdown-item>
      <b-dropdown-item class="gray-dark" v-b-modal.logout>{{$t("navigation.logout")}}</b-dropdown-item>
    </b-nav-item-dropdown>
    <b-modal id="logout" @ok="handleLogout" :title="$t('logout.message.title')">
      <p class="my-4">{{$t("logout.message.logoutConfirm")}}</p>
    </b-modal>
  </b-navbar-nav>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import ExchangeRate from '@/components/navigation/ExchangeRate.vue';
import * as api from '@/api';

export default {
  mixins: [BaseComponent],
  data() {
    return {
      manualUrl: ''
    };
  },
  created() {
    this.manualUrl = process.env.VUE_APP_MANUAL_URL;
  },
  methods: {
    handleLogout() {
      api.logout(this.$store.state.account, (item) => {
        this.$store.state.account = '';
        this.$store.state.name = '';
        this.$store.state.token = '';
        this.$store.state.role = '';
        this.$store.state.depositWarn = '';
        this.$store.state.troubleProductWarn = '';
        this.$store.state.isWarnDeposit = '';
        this.$router.push('/login');
      });
    },
    openManual() {
      api.downloadManual((base64data) => {
        const file = 'data:application/pdf;base64,' + base64data;
        let link = document.createElement('a');
        link.href = file;
        link.download = 'SLCLAS-Manual.pdf';
        link.click();
      });
    }
  },
};
</script>

<style scoped>
.gray-dark {
  background-color: #343a40;
  color: hsla(0, 0%, 100%, .5);
}
.active {
  color: white;
}
</style>

<style>
.nav-margin a {
    margin-top: 0.3rem;
}
a.dropdown-item.gray-dark {
    margin-top: 0;
}
.dropdown-menu.dropdown-menu-right.show {
    transform: translate(0, -0.3rem);
}
.dropdown-menu {
  padding-top: 0px;
  padding-bottom: 0px;
}
.dropdown-item:hover {
  color: whitesmoke;
}
.dropdown-item:last-child {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.dropdown-item:first-child {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
</style>
